
















































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapState, mapActions } from "vuex";

import { STORE_KEY, store } from "./_store";

import TitleBar from "@/components/Elements/TitleBar.vue";
import cloneDeep from "lodash/cloneDeep";
import XLSX from "xlsx";
import moment from "moment";
import PrimeCostCopyForm from "./PrimeCostCopyForm/PrimeCostCopyForm.vue";

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      "loading",
      "loaded",
      "fatalError",

      "filter",

      "documents",
      "lastMeta",
    ]),
    ...mapState("ubic", ["token", "actor"]),
    ...mapGetters(STORE_KEY, []),
  },
  methods: {
    ...mapActions(STORE_KEY, ["changeValue", "setPrimeCost"]),
  },
  components: {
    TitleBar,
    PrimeCostCopyForm,
  },
})
export default class PrimeCostsList extends Vue {
  radioButton = 1;
  documents!: any[];
  upload_file: any = null;

  get titleStack() {
    const costPriceDate = this.$route.query.costPriceDate;
    if (costPriceDate) {
      const date = moment(costPriceDate as string);
      return [
        "Каталог продуктов",
        `Себестоимость на ${date.format("MM.YYYY")}`,
      ];
    }
    return ["Каталог продуктов", "Себестоимость"];
  }

  get queryParams() {
    return cloneDeep(this.$route.query);
  }

  get defaultSort() {
    return [
      this.$route.query.sortField || "name",
      this.$route.query.sortDirection || "asc",
    ];
  }

  get selectedView() {
    return this.$route.query.view || "linked";
  }

  get costPriceDate(): any {
    return this.$route.query.costPriceDate
      ? moment(this.$route.query.costPriceDate as string).toDate()
      : null;
  }

  set costPriceDate(value: any) {
    this.$router.replace({
      query: {
        ...this.$route.query,
        costPriceDate: moment(value).format("YYYY-MM-DD"),
      },
    });
  }

  uploadFile(file: File, type: string) {
    const formData = new FormData();
    const costPriceDate = moment(this.costPriceDate).format("DD.MM.YYYY");

    formData.append("file", file);
    formData.append("date", moment(this.costPriceDate).format("YYYY-MM-DD"));

    this.$buefy.dialog.confirm({
      message: `Заменяем себестоимость из файла на дату <b>${costPriceDate}</b>?<br/><br/> <strong>Обратите внимание:</strong><ol><li>артикул берется из столбца - 3</li><li>цена берется из столбца - 4</li></ol>`,
      confirmText: "Да",
      cancelText: "Нет",
      trapFocus: true,
      onConfirm: () => {
        this.$store.dispatch(`${STORE_KEY}/startLoading`);
        // @ts-ignore
        this.$http
          .post(`/api/v1/parse_prime_costs`, formData, {})
          .then((response: any) => {
            this.handleParamsChange();
          });
      },
    });
  }

  copyPrimeCosts() {
    this.$buefy.modal.open({
      parent: this,
      component: PrimeCostCopyForm,
      hasModalCard: true,
      fullScreen: true,
      customClass: "document-form short-form",
      trapFocus: true,
    });
  }

  setFilter(filterName: string, filterValue: any) {
    this.$router.replace({
      query: {
        ...this.$route.query,
        [filterName]: filterValue,
      },
    });
  }

  onSort(field: string, direction: string) {
    this.$router.replace({
      query: {
        ...this.$route.query,
        sortField: field,
        sortDirection: direction,
      },
    });
  }

  private delayFilter: any = null;

  onSearch(filter: any) {
    console.log(filter);
    if (!this.delayFilter) {
      setTimeout(() => {
        this.$router.replace({
          query: {
            ...this.$route.query,
            ...filter,
          },
        });
        this.delayFilter = null;
      }, 3000);
    }
    this.delayFilter = filter;
  }

  onPageChange(page: string) {
    this.$router.replace({
      query: { ...this.$route.query, page },
    });
  }

  saveAllPrimeCost() {
    Promise.all(
      this.documents.map(async (document, idx) => {
        if (document.edited) {
          return this.savePrimeCost(idx, true);
        }
      })
    ).then(() => {
      this.handleParamsChange();
    });
  }

  savePrimeCost(index: number, no_reload = false) {
    return this.$store
      .dispatch(`${STORE_KEY}/savePrimeCost`, { index })
      .then((result) => {
        this.$buefy.snackbar.open(`Данные сохранены`);
        if (!no_reload) {
          this.handleParamsChange();
        }
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: "is-warning",
          message: `При сохранении возникли проблемы. Попробуйте позже.`,
        });
      });
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.handleParamsChange();
  }

  beforeDestroy() {
    this.$store.unregisterModule(STORE_KEY);
  }
  tableToExcel() {
    const csvContent: any[] = [];

    csvContent.push(...this.$store.getters[`${STORE_KEY}/exportData`]);
    const ws = XLSX.utils.aoa_to_sheet(csvContent);
    // @ts-ignore
    const range = XLSX.utils.decode_range(ws["!ref"]);
    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellref = XLSX.utils.encode_cell({ c: C, r: R }); // construct A1 reference for cell
        if (!ws[cellref] || C < 3 || R < 1) continue; // if cell doesn't exist, move on
        const cell = ws[cellref];
        cell.t = "n";
        cell.z = "0.00";
      }
    }
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Отчет");
    XLSX.writeFile(wb, "export.xlsx");
  }

  // ---------------------------------------------------------------------------

  @Watch("$route.query")
  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
  }
}
